// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ea27af62","163":"f5683d4c","200":"633dbbde","252":"46906247","410":"c000a4f1","453":"7a28cdc1","458":"8bad5883","689":"e6687277","824":"f1342faa","961":"23d56c64"}[chunkId] + ".chunk.js";
};